export default {
  fillInOrder: "Remplir la commande d'agent d'achat",
  inputTips: "(les colonnes marquées <span style='color: red'>*</span> sont obligatoires)",
  process: {
    first: 'Remplir la commande et soumettre',
    second: 'Payer le produit et les frais de livraison nationaux',
    three: "Attendre l'arrivée de votre produit à l'entrepôt",
  },
  productInfo: 'Informations sur le produit',
  productInfoTips:
    "Tous les produits disponibles pour le service d'agent d'achat affichés sur acbuy sont des produits récupérés de plateformes d'achat tierces et ne sont pas directement vendus par acbuy. Ainsi, en cas de problème de contrefaçon impliqué par les produits susmentionnés, toutes les responsabilités encourues seront à la charge des vendeurs correspondants sur la plateforme tierce, tandis qu'acbuy n'assumera aucune responsabilité connexe, subsidiaire ou conjointe.",
  fees: 'Frais',
  feeStandard: 'Barèmes de frais',
  feeStandardTips:
    "Pour la commande d'agent d'achat que vous soumettez sur cette page, si le produit provient de plateformes tierces comme Kongfuzi Used Books, Xiaohongshu et Youzan, etc., il est possible que le produit ne puisse pas être acheté. Le produit est associé à des risques d'expédition, ou des frais de service supplémentaires pourraient être facturés. Les frais de service réels doivent être vérifiés par l'agent. Pour plus de détails, veuillez consulter 'Centre d'aide - Barèmes de frais de service d'agent d'achat tiers'.",
  link: 'Lien',
  name: 'Nom',
  remark: 'Remarque',
  unitPrice: 'Prix unitaire (CNY)',
  qty: 'Qté',
  goodsAttr: 'Spécifications ou matériau',
  chinaPostage: "Frais d'expédition (CNY)",
  holder: {
    inputUrl: "Veuillez coller l'URL du produit",
    inputName: 'Veuillez saisir le nom du produit ici (Maximum 100 caractères)',
    inputAttr: 'Veuillez saisir la spécification des produits',
    inputRemark:
      "Si l'article a plusieurs motifs, tailles, couleurs, etc., veuillez spécifier ce dont vous avez besoin ici en fonction de la description de la classification sur la page du produit. Si vous achetez le même produit mais avec des spécifications différentes, veuillez séparer la commande.",
    contactName: 'Veuillez saisir votre nom de contact',
    contactEmail: 'Veuillez saisir votre adresse e-mail de contact',
    contactPhone: 'Veuillez saisir votre numéro de téléphone de contact',
  },
  other: 'Autre (facultatif)',
  productImg: 'Images du produit',
  fareTip:
    "Les frais d'expédition nationaux vers notre entrepôt (en cas de doute, veuillez saisir 0, l'agent vérifiera et initiera un paiement)",
  customizedLogisticsForm: 'Formulaire de demande de logistique personnalisée',
  submitInfo: 'Soumettre les informations sur le produit',
  customizedProcess: {
    first: 'Remplir la commande et soumettre',
    second: 'Soumettre les informations sur le produit',
    three: "Attendre qu'acbuy vous contacte",
  },
  deliveryAddress: 'Adresse de livraison',
  contactDetail: 'Coordonnées',
  contactName: 'Nom du contact',
  contactPhone: 'Téléphone du contact',
  contactEmail: 'E-mail du contact',
  customizedLogisticsInformation: 'Informations de logistique personnalisée',
  fromWarehouse: "De l'entrepôt",
  manuallyFill: 'Remplir manuellement les informations sur le produit',
  contactInfoTips1:
    '· Afin de mieux vous servir, veuillez remplir le formulaire de manière véridique et détaillée. Dans les trois jours ouvrables suivant la soumission de la demande, un personnel dédié vous contactera.',
  contactInfoTips2:
    '· Pour les colis de moins de 30 kg, il est conseillé aux clients de choisir la livraison logistique en ligne.',
  contactInfoTips3:
    "· Les services personnalisés ne concernent que le transport logistique, et les marchandises ne sont inspectées que pour l'apparence, et une inspection de qualité détaillée des marchandises n'est pas fournie.",
  myWarehouse: 'Mon entrepôt',
  itemName: "Nom de l'article",
  volume1: 'Dimensions du colis après emballage',
  volume: 'Volume (cm)',
  weight: 'Poids',
  length: 'Longueur',
  width: 'Largeur',
  height: 'Hauteur',
  warehouseItem: 'Article en entrepôt',
  manuallyItem: 'Article manuel',
  submitSuccess: 'Demande de logistique personnalisée soumise avec succès',
  submitMsg: 'Nous vous contacterons dès que possible, veuillez patienter.',
  inputProductMsg: 'Veuillez saisir le message du produit',
  selectZone: "Veuillez sélectionner l'indicatif régional pour le numéro de téléphone de contact",
  productName: 'Lien ou nom du produit',
}
